/**
 * Style config for legacy ct-design Accordion filter headers.
 * Revamp uses FilterAccordion instead — do not add revamp branches here.
 */
export const getFilterAccordionStyleConfig = (customRootClassName?: string) => ({
  root: {
    className: ['p-0', 'c-pointer', customRootClassName].filter(Boolean).join(' '),
  },
  title: {
    css: {
      fontSize: '12px',
      lineHeight: '16px',
      color: '#808080',
      textTransform: 'uppercase',
    },
  },
  titleContainer: {
    className: 'flex flex-row flex-middle',
    css: {
      flexDirection: 'row !important',
    },
  },
  clearText: {
    css: {
      color: '#0F6BFF',
      display: 'flex',
      alignItems: 'center',
    },
  },
  childrenContentContainer: {
    css: {
      overflow: 'visible',
    },
  },
})
